import {
  minimumWidth,
  pxToRem,
  styled,
  Link,
  textStyle,
} from '@feast-it/ui/light';
import { css } from '@emotion/core';

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colors.white};
    border-radius: ${theme.radii[1]};
    overflow: hidden;
    border: 1px solid ${theme.colors.lightGrey};
  `};
`;

export const ArrowSpaceDivider = styled.div`
  ${({ theme }) => css`
    width: ${theme.spacing[4]};
  `};
`;

// Function to create styled carousel - will be used with dynamic import
export const createStyledCarousel = (CarouselComponent: any) => styled(
  CarouselComponent
)`
  ${({ theme }) => css`
    width: 100%;

    .glide__arrows {
      display: flex;
      gap: ${theme.spacing[2]};
      justify-content: center;
      align-items: center;
    }

    .glide__arrow {
      background: ${theme.colors.white};
      border: 1px solid ${theme.colors.lightGrey};
      box-shadow: none;
      padding: ${theme.spacing[2]};
    }
  `};
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: grid;

    ${minimumWidth(theme.breakpoints.medium)} {
      grid-template-columns: 5fr 7fr;
    }
  `};
`;

export const BackgroundImage = styled.div<{
  backgroundImage: string;
}>`
  ${({ theme, backgroundImage }) => css`
    background-image: url('${backgroundImage}');
    background-position: center;
    background-size: cover;
    min-height: ${pxToRem(200)};
    height: 100%;

    ${minimumWidth(theme.breakpoints.medium)} {
      min-height: ${pxToRem(340)};
      grid-area: 1 / 2;
    }
  `};
`;

export const Content = styled.div`
  ${({ theme }) => css`
    ${minimumWidth(theme.breakpoints.medium)} {
      grid-area: 1 / 1;
    }
  `};
`;

export const TextWrapper = styled.div`
  ${({ theme }) => css`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: ${theme.spacing[8]} ${theme.spacing[4]};

    ${minimumWidth(theme.breakpoints.small)} {
      padding: ${theme.spacing[8]} ${theme.spacing[6]};
    }

    ${minimumWidth(theme.breakpoints.medium)} {
      padding: ${theme.spacing[8]} ${theme.spacing[6]};
    }
  `};
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${pxToRem(16)};
    line-height: 1.5;
    color: ${theme.colors.darkGrey};
    margin-top: ${theme.spacing[3]};

    ${minimumWidth(theme.breakpoints.medium)} {
      max-width: ${pxToRem(360)};
    }
  `};
`;

export const StyledLink = styled(Link)`
  ${({ theme }) => css`
    line-height: 1.5;
    margin-top: ${theme.spacing[9]};
    display: inline-flex;
    align-items: flex-start;
    gap: ${theme.spacing[2]};

    ${textStyle(theme, 'bodyMedium', 'mediumBlue')};

    &:hover {
      text-decoration: underline;
    }
  `};
`;
